import { render } from "./FeaturedUsers.vue?vue&type=template&id=3f84d550"
import script from "./FeaturedUsers.vue?vue&type=script&lang=ts"
export * from "./FeaturedUsers.vue?vue&type=script&lang=ts"
script.render = render

export default script